import { FC, PropsWithChildren } from 'react';
import type { ApiError } from 'utils/http/apiErrorHelper';

import { DiscardButton, RequestButton } from './buttons';
import { ErrorFeedback } from './errorFeedback';
import { Spacer } from './spacer';

export const InitializedActions: FC<
  PropsWithChildren<{
    creationError?: ApiError;
    onDiscarded: () => void;
    onRequested: () => void;
    onDimissCreationError: () => void;
  }>
> = ({ creationError, onDiscarded, onRequested, onDimissCreationError }) => (
  <>
    <DiscardButton onDiscarded={onDiscarded} className="flex-grow-1" />
    <Spacer />
    {creationError ? (
      <ErrorFeedback
        errorType="creation"
        error={creationError}
        className="flex-grow-1"
        onDimiss={onDimissCreationError}
      />
    ) : (
      <RequestButton onRequested={onRequested} className="flex-grow-1" />
    )}
  </>
);
